// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'waypoint';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M9 7.938a3.188 3.188 0 1 0 0-6.376 3.188 3.188 0 0 0 0 6.375zm0 0v5.843m2.125-2.546c3.073.326 5.313 1.346 5.313 2.55 0 1.467-3.33 2.656-7.438 2.656s-7.438-1.193-7.438-2.66c0-1.204 2.231-2.215 5.292-2.544'
  />
);

export const viewBox = '0 0 18 18';
